/* eslint-disable */
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Info from '@/Components/InfoTab/Info';
import { urls } from '@/Constants';
import GrnHeader from '@/Pages/GRNPage/grnHeader';
import ImageContainer from './imageContainer';
import {
	handleImagePreview, inputHelper, keyPressHandler,
	useQuery
} from '@/Helpers';
import useKeyPress from '@/Helpers/useKeyPress';

const fieldsMap = {
	'QR ID': 'qrId',
	'Marked at Store': 'markStore',
	Reason: 'reason',
	'SKU type': 'skuType',
	'Receiving Date': 'receivingDate',
	'Marking Date': 'markingDate',
	'Shelf life at receiving': 'recevingShelfLife',
	'Shelf Life at Marking': 'markingShelfLife',
	'Expiry Date': 'expiryDate',
	Quantity: 'qty',

};
function WastageDetails() {
	const query = useQuery();
	const dateRange = query?.get('dateRange');
	const [wastageInfo, setWastageInfo] = useState({});
	const location = useLocation();
	const { data: wastageData, idx } = location?.state;
	const [images, setImages] = useState([]);
	const wastageList = useSelector((state) => state.wastage.wastageList);
	const history = useHistory();
	const backUrl = `${urls.EXTENSION}${urls.WASTAGE_TRANSIT_LOGS}?dateRange=${dateRange}`;
	const keyPressed = useKeyPress();

	useEffect(() => {
		setWastageInfo({
			name: wastageData?.productVariantName ?? 'N/A',
			qrId: wastageData?.qrCode ?? 'N/A',
			markStore: wastageData?.fromStore ?? 'N/A',
			reason: wastageData?.wastageReason ?? 'N/A',
			skuType: wastageData?.skuType ?? 'N/A',
			receivingDate: moment(wastageData?.stockedInAt).format('DD-MM-YYYY') ?? 'N/A',
			markingDate: moment(wastageData?.wastageDateTime).format('DD-MM-YYYY HH:mm') ?? 'N/A',
			recevingShelfLife: wastageData?.shelfLifeAtReceiving ? `${wastageData?.shelfLifeAtReceiving}%` : 'N/A',
			markingShelfLife: wastageData?.shelfLifeAtMarking ? `${wastageData?.shelfLifeAtMarking}%` : 'N/A',
			expiryDate: moment(wastageData?.expiryDate).format('DD-MM-YYYY') ?? 'N/A',
			qty: `${wastageData?.qty} ${wastageData?.unit === 'count' ? 'pcs' : wastageData?.unit}` ?? 'N/A',
		});
		setImages(wastageData?.images ?? []);
	}, [wastageData]);

	const navigateQc = (e) => {
		const { dataset } = inputHelper(e);
		let newListItem = null;
		let newIdx = null;

		if (dataset.type === 'next') {
			newListItem = wastageList?.[idx + 1];
			newIdx = idx + 1;
		} else {
			newListItem = wastageList?.[idx - 1];
			newIdx = idx - 1;
		}

		if (newListItem) {
			history.push({
				pathname: `${urls.EXTENSION}${urls.WASTAGE_LOG_DETAILS}`,
				search: `?dateRange=${dateRange}`,
				state: {
					data: newListItem,
					idx: newIdx,
				},
			});
		}
	};

	useEffect(() => {
		const qcData = wastageList?.[idx] ?? null;
		if (
			(keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight') &&
			qcData !== null
		) {
			const result = keyPressHandler(
				keyPressed,
				wastageList,
				idx
			);

			if (result) {
				let newIdx;
				if (keyPressed === 'ArrowRight') {
					newIdx = idx + 1;
				} else {
					newIdx = idx - 1;
				}

				history.push({
					pathname: `${urls.EXTENSION}${urls.WASTAGE_LOG_DETAILS}`,
					search: `?dateRange=${dateRange}`,
					state: {
						data: result,
						idx: newIdx,
					},
				});
			}
		}
	}, [keyPressed]);

	return (
		<>
			<GrnHeader
				title='Back to Wastage Management'
				navigateLabel='QR ID'
				url={backUrl}
				id={wastageData?.qrCode}
				navigatePrevToolTip='Prev Wastage'
				navigateNextToolTip='Next Wastage'
				navigateQC={navigateQc}
				listData={wastageList}
				idx={idx}
			/>
			<div className='mt-12'>
				<Info
					fieldMap={fieldsMap}
					data={wastageInfo}
					heading={{
						value: wastageInfo?.name,
					}}
				/>
				<div className='w-[97%] block mx-auto'>
					<span className='text-black bg-yellow-500 px-4 py-2 hover:bg-yellow-400 rounded-tl-[8px] rounded-tr-[8px] border-b border-black'>Wastage Images</span>
					<ImageContainer
						images={[...images]}
						handleClick={handleImagePreview}
					/>
				</div>
			</div>
		</>
	);
}
export default WastageDetails;
